'use client';

import { useRouter } from 'next/navigation';

export function useRouterNav() {
  const router = useRouter();

  const handleNavigation = (path: string, forceReload: boolean = false) => {
    if (forceReload) {
      router.refresh();
      return;
    }

    if (path) {
      router.push(path);
    }
  };

  const handleOffRouteChange = () => {
    console.warn(
      'handleOffRouteChange is not supported in App Router. Use useEffect instead.'
    );
  };

  const handleOnRouteChange = () => {
    console.warn(
      'handleOnRouteChange is not supported in App Router. Use useEffect instead.'
    );
  };

  return {
    handleNavigation,
    handleOffRouteChange,
    handleOnRouteChange
  };
}
